import React, { useState } from 'react';

export default function WidgetTitle(props) {
    const className = 'widget-title ' + (props.className || '');
    return (
        <h3 className={className}>{props.children}</h3>
    );
}